"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadImageRoutine = void 0;
var redux_saga_routines_1 = require("redux-saga-routines");
exports.uploadImageRoutine = (0, redux_saga_routines_1.createRoutine)("ARTICLE/UPLOAD_IMAGE");
